import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Application } from '@modules/common/types/application';
import { VirtualFolder } from '@modules/files/types/virtual-folder';
import { AdvancedSearchService } from '@modules/search/services/advanced-search.service';

@Component({
  selector: 'app-files-list-context-menu',
  templateUrl: './files-context-menu.component.html',
  styleUrls: ['./files-context-menu.component.less'],
  standalone: false,
})
export class FilesContextMenuComponent {
  // Input
  @Input() filterKey: VirtualFolder;

  // Outputs
  @Output() change = new EventEmitter<VirtualFolder>();

  protected readonly searchService = inject(AdvancedSearchService);
  protected readonly isAdvancedSearchApplied = toSignal(this.searchService.isAdvancedSearchApplied(Application.files), {
    initialValue: false,
  });

  selectFilter(filter: VirtualFolder) {
    this.change.emit(filter);
  }
}
